// @mui material components
import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Button,
  Grid,
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
} from "@mui/material";

import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "../../axios";
// import DataTable from "theme/Tables/DataTable";
import usePageTitle from "../pageTitle";
import { PieChart } from "@mui/x-charts";
import CheckoutFooter from "../components/footer";
import { usePDF, Resolution, Margin } from "react-to-pdf";
import AppConfig from "../../appConfig";
import GoogleMapReact from "google-map-react";

function DawLeaderboardPage() {
  const pageTitle = "Display & Win - Leaderboard";
  usePageTitle(pageTitle);
  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [mapZoom, setMapZoom] = useState(12);

  const [reportName, setReportName] = useState("reports_overview.pdf");
  const options = {
    filename: reportName,
    // default is `save`
    // method: "open",
    // default is Resolution.MEDIUM = 3, which should be enough, higher values
    // increases the image quality but also the size of the PDF, so be careful
    // using values higher than 10 when having multiple pages generated, it
    // might cause the page to crash or hang.
    // resolution: Resolution.HIGH,
    page: {
      // margin is in MM, default is Margin.NONE = 0
      // margin: Margin.SMALL,
      // default is 'A4'
      // format: "letter",
      // default is 'portrait'
      // orientation: "landscape",
    },
    // canvas: {
    //   // default is 'image/jpeg' for better size performance
    //   mimeType: "image/png",
    //   qualityRatio: 1,
    // },
    // // Customize any value passed to the jsPDF instance and html2canvas
    // // function. You probably will not need this and things can break,
    // // so use with caution.
    overrides: {
      // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
      pdf: {
        compress: true,
      },
      // see https://html2canvas.hertzen.com/configuration for more options
      canvas: {
        // useCORS: true,
        imageTimeout: 10000,
      },
    },
  };
  const { toPDF, targetRef } = usePDF(options);

  const [leaderboard, setLeaderboard] = useState([]);
  const [resultData, setResultData] = useState({});
  const [stats, setStats] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`campaign/window/daw/report/${ref}`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setResultData(result.data.data);
            setStats(result.data.data.stats);
            setLeaderboard(result.data.data.leaderboard);

            // Handle App Update
            const currentVersion = localStorage.getItem(
              AppConfig.app_version_store,
            );
            const newVersion = result.data.version;
            if (currentVersion !== newVersion) {
              localStorage.setItem(AppConfig.app_version_store, newVersion);
              if (
                window.confirm("New version available. Reloading...") === true
              ) {
                window.location.reload(true);
              } else {
                window.location.reload(true);
              }
              return;
            }

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  function getPieChartColors(data) {
    const colors = [
      "info",
      "primary",
      "secondary",
      "error",
      "warning",
      "success",
    ];
    const bgColors = [];
    data.every(() => {
      bgColors.push(colors[Math.floor(Math.random() * colors.length)]);
      return true;
    });

    return bgColors;
  }

  function getPieChartLabels(data) {
    const labels = [];
    data.every((row) => {
      labels.push(row.label);
      return true;
    });

    return labels;
  }

  function getPieChartData(data) {
    const datas = [];
    data.every((row) => {
      datas.push(row.count);
      return true;
    });

    return datas;
  }

  return (
    <Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Box
        sx={{ width: { xs: "95%", md: "80%", lg: "80%" }, margin: "0px auto" }}
        ref={targetRef}
      >
        {pageLoaded && (
          <Box mb={5}>
            <Box>
              <Paper elevation={0}>
                <Box p={2} align="center">
                  <Box mt={0} display="flex" justifyContent="space-between">
                    <Box>
                      <Typography variant="h6" fontWeight={400}>
                        <Icon color="info">bar_chart</Icon>
                      </Typography>
                    </Box>
                    <Box>
                      <Button
                        onClick={() => {
                          setRefreshPage(!refreshPage);
                        }}
                      >
                        <Icon>replay</Icon>
                      </Button>
                      <Button
                        onClick={() => {
                          // toPDF();
                          window.print();
                        }}
                      >
                        <Icon>print</Icon>
                      </Button>
                    </Box>
                  </Box>
                  <Box mt={2}>
                    <img
                      src={`${AppConfig.api_media_url}${resultData.campaign.account.logo}`}
                      alt="img"
                      style={{ maxWidth: 200, maxHeight: "80%" }}
                    />
                  </Box>
                  <Box mt={1}>
                    <Typography variant="subtitle1" fontWeight={500}>
                      {resultData.campaign.account.title}
                    </Typography>
                  </Box>
                  <Box mt={1}>
                    <Typography variant="caption" fontWeight={350}>
                      {resultData.campaign.title}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Box>
            <Box mt={5}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={8} lg={8}>
                  <Box>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6} lg={6}>
                        <Card>
                          <Box p={2} align="center">
                            <Typography variant="h6" fontSize={24}>
                              <Icon>storefront</Icon>
                            </Typography>
                            <Typography mt={2} variant="h6" fontSize={36}>
                              {stats.retailers.registered}
                            </Typography>
                            <Typography
                              mt={2}
                              variant="subtitle2"
                              fontSize={14}
                              fontWeight={300}
                            >
                              Registered
                              <br /> Retailers
                            </Typography>
                          </Box>
                        </Card>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <Card>
                          <Box p={2} align="center">
                            <Typography variant="h6" fontSize={24}>
                              <Icon>store</Icon>
                            </Typography>
                            <Typography mt={2} variant="h6" fontSize={36}>
                              {stats.retailers.active}
                            </Typography>
                            <Typography
                              mt={2}
                              variant="subtitle2"
                              fontSize={14}
                              fontWeight={300}
                            >
                              Active
                              <br />
                              Retailers
                            </Typography>
                          </Box>
                        </Card>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <Card>
                          <Box p={2} align="center">
                            <Typography variant="h6" fontSize={24}>
                              <Icon>location_on</Icon>
                            </Typography>
                            <Typography mt={2} variant="h6" fontSize={36}>
                              {stats.visits.visits}
                            </Typography>
                            <Typography
                              mt={1.5}
                              variant="subtitle2"
                              fontSize={14}
                              fontWeight={300}
                            >
                              Total
                              <br />
                              Visits
                            </Typography>
                          </Box>
                        </Card>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <Card>
                          <Box p={2} align="center">
                            <Typography variant="h6" fontSize={24}>
                              <Icon>loyalty</Icon>
                            </Typography>
                            <Typography mt={2} variant="h6" fontSize={36}>
                              {stats.visits.points}
                            </Typography>
                            <Typography
                              mt={1.5}
                              variant="subtitle2"
                              fontSize={14}
                              fontWeight={300}
                            >
                              Total
                              <br />
                              Points
                            </Typography>
                          </Box>
                        </Card>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                  <Paper sx={{ height: "100%" }}>
                    <Box p={1}>
                      <Box p={2} mb={3}>
                        <Typography>Product Breakdown</Typography>
                      </Box>
                      <PieChart
                        series={[
                          {
                            data: stats.products,
                          },
                        ]}
                        paddingAngle={10}
                        height={200}
                      />
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
            {stats.retailers.retailerSpreadData.length > 0 && (
              <Box mt={5}>
                <Card>
                  <Box p={3}>
                    <Box mb={3} display="flex" justifyContent="space-between">
                      <Box>
                        <Typography>Retailer HeatMap</Typography>
                      </Box>
                      <Box>
                        <IconButton
                          size="small"
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            let pZoom = mapZoom;
                            pZoom -= 1;
                            pZoom = pZoom < 4 ? 4 : pZoom;
                            setMapZoom(pZoom);
                          }}
                        >
                          <Icon>remove</Icon>
                        </IconButton>
                        &nbsp;
                        <Typography
                          variant="caption"
                          fontSize={10}
                          fontWeight="light"
                        >
                          Zoom
                        </Typography>
                        &nbsp;
                        <IconButton
                          size="small"
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            let pZoom = mapZoom;
                            pZoom += 1;
                            pZoom = pZoom > 20 ? 20 : pZoom;
                            setMapZoom(pZoom);
                          }}
                        >
                          <Icon>add</Icon>
                        </IconButton>
                      </Box>
                    </Box>
                    <Box sx={{ height: "65vh", width: "100%" }}>
                      <GoogleMapReact
                        bootstrapURLKeys={{ key: AppConfig.google_map_key }}
                        defaultCenter={{
                          lat: stats.retailers.retailerSpreadData[0].latitude,
                          lng: stats.retailers.retailerSpreadData[0].longitude,
                        }}
                        defaultZoom={mapZoom}
                        zoom={mapZoom}
                      >
                        {stats.retailers.retailerSpreadData.map((loc) => (
                          <Box lat={loc.latitude} lng={loc.longitude}>
                            <Typography fontSize={24}>
                              <Icon color="error">location_on</Icon>
                            </Typography>
                          </Box>
                        ))}
                      </GoogleMapReact>
                    </Box>
                  </Box>
                </Card>
              </Box>
            )}

            <Box mt={5}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                  <Paper>
                    <Box p={1}>
                      <PieChart
                        series={[
                          {
                            data: stats.retailers.statesStats,
                          },
                        ]}
                        paddingAngle={10}
                        height={200}
                      />
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Paper>
                    <Box p={1}>
                      <PieChart
                        series={[
                          {
                            data: stats.retailers.lgaStats,
                          },
                        ]}
                        paddingAngle={10}
                        height={200}
                      />
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
            <Box mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <Box p={0}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box p={2}>
                      <Typography variant="h6" fontWeight="medium">
                        Retailer Leaderboard
                      </Typography>
                    </Box>
                  </Box>
                  <Box mt={1}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Rank</TableCell>
                          <TableCell>Retailer</TableCell>
                          <TableCell>Points</TableCell>
                          <TableCell>Visits</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {leaderboard.map((row) => (
                          <TableRow>
                            <TableCell>{row.rank}</TableCell>
                            <TableCell>{row.retailer}</TableCell>
                            <TableCell>{row.points}</TableCell>
                            <TableCell>{row.visits}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                </Box>
              </Card>
            </Box>
          </Box>
        )}
      </Box>
      <CheckoutFooter />
    </Box>
  );
}

export default DawLeaderboardPage;
